<template>
    <div class="flex-center flex-col h-full">
        <IconNoDataCry
            v-if="!hideEmptyIcon"
            class="w-32"
        />
        <h3 class="text-main-xl text-center">
            {{ t('general.noData') }}
        </h3>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import get from 'lodash/get'
import { WidgetExtended } from '@/types/dashboard'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/* Props */
const props = defineProps<{
    widget: WidgetExtended
}>()

/* Computed */
const hideEmptyIcon = computed(() => {
    return get(props.widget, 'WidgetLayout.TemplateSettings.HideEmptyIcon', false)
})
</script>

<style scoped lang="scss">

</style>
